<div class="canvas-wrapper" [ngClass]="getGradientClass()" [class.is-fixed-height]="isFixedHeight">
  <ng-content></ng-content>
</div>
